import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '../../../../components/lists/list-item/list-item';
import { DataVariant, ListItemData } from '../../../../components/lists/list-item/types';
import { formatDate } from '../../../../helpers/date-formatters';
import { formatNumber } from '../../../../helpers/number-formatters';
import { MoneyTransferListItem as ListItemDataInput } from '../../../../logic/graphql/types/types.d';
import { Paths } from '../../../../navigation/paths';
import { useIntl } from 'react-intl';

const MoneyTransferListItem = (props: {
  listItem: ListItemDataInput;
  style?: React.CSSProperties | undefined;
  mobileHeight?: number;
}): JSX.Element => {
  const intl = useIntl();
  const history = useHistory();

  const handleOnClick = (): void => {
    history.push(Paths.money_transfers + '/' + props.listItem.transaction_code);
  };

  const data: ListItemData = {
    status: props.listItem.status,
    iconVisible: true,
    title: props.listItem.currency.currency,
    transactionCode: props.listItem.transaction_code,
    detailBlocks: [
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'moneyTransfers.listItem.fromAccountLabel' }),
            value: props.listItem.from_account,
          },
        ],
      },
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'moneyTransfers.listItem.amountLabel' }),
            value: formatNumber(props.listItem.amount, props.listItem.currency.currency),
            variant: DataVariant.highlighted,
          },
        ],
      },
    ],
    date: formatDate(props.listItem.order_date),
  };

  return (
    <ListItem
      onClick={handleOnClick}
      data={data}
      style={props.style}
      mobileHeight={props.mobileHeight}
    />
  );
};

export default MoneyTransferListItem;
